<div class="references-panel-parent px-0" id="referencesSection">
  <div class="row">
    <div class="d-flex w-100">
      <div class="flex-grow-1">{{"CRM.REFERENCES.REFERENCED_COMPANIES" | translate}} <span>({{companyReferences?.length || 0}})</span></div>
      <div *ngIf="companyReferences && companyReferences.length > 0">
        <button class="btn btn-primary btn-split" (click)="handleSplit($event)">{{split ? 'COMBINE' : 'SPLIT'}}</button>
      </div>
    </div>
  </div>
  <div class="references-panel">
    <div *ngIf="!companyReferences || companyReferences.length === 0" class="p-2 references-container empty">{{"CRM.REFERENCES.REFERENCE_INFO" | translate}}</div>
    <div *ngIf="!split && companyReferences && companyReferences.length > 0" class="references-container">
      <ul class="references" >
        <li class="reference" *ngFor="let item of companyReferences">
          <ng-container *ngTemplateOutlet="referenceItem; context:{item:item}"></ng-container>
        </li>
      </ul>
    </div>
    <div *ngIf="split && companyReferences && companyReferences.length > 0" class="d-flex flex-column references-container">
      <div class="references-title">{{"GENERICS.PUBLIC" | translate | uppercase }}</div>
      <ul class="references">
        <li class="reference" *ngFor="let item of getPublics()">
          <ng-container *ngTemplateOutlet="referenceItem; context:{item:item}"></ng-container>
        </li>
      </ul>
      <div class="references-title">{{"GENERICS.PRIVATE" | translate | uppercase }}</div>
      <ul class="references">
        <li class="reference" *ngFor="let item of getPrivates()">
          <ng-container *ngTemplateOutlet="referenceItem; context:{item:item}"></ng-container>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #referenceItem let-item="item">
    <a *ngIf="item.referencedId" class="pill-reference"
       [routerLink]="['/' +
       (item.referencedType === 'INDICATION' ? 'indications' :
       (item.referencedType === 'CONFERENCE' ? 'conferences' : item.referencedType.toLowerCase()))
       , item.referencedId]"
       target="_blank">
      {{item.referencedLabel}}  {{ item.ticker ? '(' + item.ticker + ')' : ''}}
    </a>

    <span *ngIf="!item.referencedId" class="pill-reference no-landing">
      {{item.referencedLabel}}  {{ item.ticker ? '(' + item.ticker + ')' : ''}}
    </span>
</ng-template>
